<template>
  <div
    class="contactPreviewCard"
    :class="{'inset': inset}"
    >
    <v-layout
        row
        wrap
    >
        <div
            v-if="!searching"
            style="display:flex;align-items: center;width:100%;"
        >
            <img
                :src="getIconPath(local_case_type.id)"
                style="max-height:75px;"
            />
            <div
                style="font-size: 18px;font-weight: bold;margin-left: 10px;flex-grow: 1;"
                :class="{'small-title': inset}"
            >
                {{ local_case_type.name }}<br />
            </div>
            <div
                v-if="clearable"
            >
                <v-btn
                    fab
                    flat
                    @click="$emit('clear')"
                >
                    <v-icon>
                        close
                    </v-icon>
                </v-btn>
            </div>
        </div>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'CaseTypePreview',
    props: ['id', 'inset', 'case_type', 'clearable'],
    data () {
      return {
        local_case_type: null,
        searching: false
      }
    },
    created () {
        if (this.case_type) {
            this.local_case_type = JSON.parse(JSON.stringify(this.case_type))
        } else {
            if (this.id)
                this.loadCase()
        }
    },
    methods: {
        loadCase () {
            this.searching = true
            api.cases.casetype.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_case_type = data
                })
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
    }
}
</script>

<style scoped>
.contactPreviewCard {
    background:rgba(0,0,0,0.05);
    padding:5px;
    border-radius:5px;
    cursor: pointer;
    max-height: 100px;
}
.contactPreviewCard:hover {
    background:rgba(0,0,0,0.1);
}

.inset {
    background: unset;
}

.small-title {
    font-size: 12px !important;
    font-weight: 900 !important;
}
</style>